// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const KindergartenPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.kindergarten0{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
	.kindergarten1{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
</style>
<g>
	<path class="kindergarten0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
	<path class="kindergarten1" d="M99,70.7c0,9-7.3,16.4-16.4,16.4c-9,0-16.4-7.3-16.4-16.4c0-9,7.3-16.4,16.4-16.4S99,61.6,99,70.7z M47.4,54.3
		l19-32.8l19,32.8H47.4z M56.4,86.9H23.7V54.3h32.7V86.9z"/>
</g>
</svg>
`);

export const KindergartenIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <KindergartenPure className={props.iconClassName} />
);

KindergartenIcon.displayName = 'KindergartenIcon';
